import { useEffect, useState } from 'react';

function useDebouncedEffect(callback, delay, dependencies) {
    const [timer, setTimer] = useState(null);

    useEffect(() => {
        // Clear the existing timer when any dependencies change
        if (timer) clearTimeout(timer);

        // Set a new timer with the delay
        const newTimer = setTimeout(callback, delay);
        setTimer(newTimer);

        // Cleanup function to clear the timer when the component unmounts or dependencies change
        return () => clearTimeout(newTimer);
    }, [...dependencies]); // eslint-disable-line react-hooks/exhaustive-deps

    // Optionally, you can handle component unmount in here as well by returning a cleanup function
}

export default useDebouncedEffect;